import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Grid,
  Button,
  useMediaQuery
} from '@mui/material';
import { ExternalLink } from '../../../components';
import { BASE_FILE_URL } from '../util';

export const CareTips = () => {
  const isMobile = useMediaQuery('(max-width: 960px)');
  const gridSize = isMobile ? 12 : 6;

  return (
    <Box>
      <Typography variant="h3" sx={{ mt: 4 }}>
        Care Tips & Extended Warranty
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Want to keep your home running smoothly for years to come?
      </Typography>
      <Typography variant="body1" sx={{ mb: 5 }}>
        Explore our collection of home care tips and learn how to make the most of your extended
        warranties. Whether it's routine maintenance or protecting your systems and finishes, we've
        got the guidance you need to stay ahead and feel confident in every season of homeownership.
      </Typography>
      <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
        {careTips.map(tip => {
          return (
            <Accordion key={tip.name}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{tip.name}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  {tip.links.map(link => (
                    <Grid item xs={gridSize} key={link.name}>
                      <Button
                        variant="contained"
                        component={ExternalLink}
                        to={link.linkUrl}
                        type="smallWhite"
                        target="_blank"
                      >
                        {link.name}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};

const careTips = [
  {
    name: 'Grinder Pump',
    links: [
      {
        name: 'Grinder Pump Information',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Grinder Pump information.pdf`
      }
    ]
  },
  {
    name: 'HVAC',
    links: [
      {
        name: 'Carrier HVAC Warranty and Registration',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Carrier HVAC warranty & registration.pdf`
      }
    ]
  },
  {
    name: 'Pfister Plumbing',
    links: [
      {
        name: 'Pfister Warranty',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Pfister Warranty.pdf`
      }
    ]
  },
  {
    name: 'Samsung Appliances',
    links: [
      {
        name: 'Samsung Product Registration ',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Samsung Product Registration (2).pdf`
      }
    ]
  },
  {
    name: 'Shaw Flooring and Tile',
    links: [
      {
        name: 'Hardwood Care and Maintenance',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Hardwood Care & Maintenance  090524.pdf`
      },
      {
        name: 'LVP Care and Maintenance ',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/LVP Care & Maintenance 090524.pdf`
      },
      {
        name: 'Shaw Flooring Warranty',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Shaw Flooring Warranty 090524.pdf`
      },
      {
        name: 'Tile and Grout Care and Maintenance ',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Tile & Grout Care & Maintenance 090524.pdf`
      }
    ]
  },
  {
    name: 'Shingles',
    links: [
      {
        name: 'Asphalt-Shingle Warranty',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Asphalt-shingle-warranty.pdf`
      },
      {
        name: 'Certainteed Shingles Certificate ',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Certainteed Shingles Certificate.pdf`
      }
    ]
  },
  {
    name: 'Siding',
    links: [
      {
        name: 'Hardie Siding Core Products HZ10 Warranty',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Hardie Siding Core Products HZ10 Warranty.pdf`
      }
    ]
  },
  {
    name: 'Water Heater',
    links: [
      {
        name: 'How to Avoid a Frozen Tankless Water Heater',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/How to avoid a frozen tankless water heater.pdf`
      },
      {
        name: 'Navien Builder Closing Flyer',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Navien Builder Closing Flyer.pdf`
      },
      {
        name: 'Navien NPN Consumer Brochure',
        linkText: 'Click Here ',
        linkUrl: `${BASE_FILE_URL}/Navien NPN Consumer Brochure Flip 2101.pdf`
      },
      {
        name: 'Navien Warranty Registration',
        linkText: 'Click Here ',
        linkUrl: `${BASE_FILE_URL}/Navien Warranty Registration.pdf`
      }
    ]
  },
  {
    name: 'Windows',
    links: [
      {
        name: 'Window Warranty',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Window Warranty.pdf`
      }
    ]
  },
  {
    name: 'Wolf Cabinets',
    links: [
      {
        name: 'Wolf Cabinet Care Tips and Warranty ',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/Wolf Cabinet Care Tips & Warranty.pdf`
      }
    ]
  },
  {
    name: 'Integrity Cabinets ',
    links: [
      {
        name: 'Integrity Cabinet Warranty Info',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/ProWarranty01_01_2024.pdf`
      }
    ]
  },
  {
    name: 'GE Appliances',
    links: [
      {
        name: 'GE Appliances Warranty Info',
        linkText: 'Click Here',
        linkUrl: `${BASE_FILE_URL}/ge warranty.pdf`
      }
    ]
  }
];
